import { IAdvertiserDomain } from "advertiser/model"
import { searchAdvertiserDomainByName } from "advertiser/tools/common"
import { translate } from "app/language/service"
import React from "react"
import { EntitiesSelect } from "ui/components/EntitiesSelect"

interface IAdvertiserDomainSelectProps {
  id?: string
  required?: boolean
  disabled?: boolean
  error?: string
  defaultSelectedEntityIds?: number[]
  defaultAdvertiserDomains?: IAdvertiserDomain[]
  minFilterLength?: number
  onChange: (advertiserDomains: IAdvertiserDomain[]) => any
  onBlur?: () => any
  sx?: any
}

export const AdvertiserDomainSelect = React.memo(
  ({
    id,
    defaultAdvertiserDomains,
    defaultSelectedEntityIds,
    error,
    required,
    disabled,
    minFilterLength,
    onChange,
    onBlur,
    sx
  }: IAdvertiserDomainSelectProps): JSX.Element => (
    <EntitiesSelect
      id={id || "advertiser-domain-select"}
      required={required}
      disabled={disabled}
      error={!!error}
      defaultSelectedEntities={defaultAdvertiserDomains}
      defaultSelectedEntityIds={defaultSelectedEntityIds}
      inputLabel={translate("label.advertiser-domains")}
      inputPlaceholder={translate("label.search.name")}
      minFilterLength={minFilterLength}
      onBlur={onBlur}
      sx={sx}
      getOptionLabel={(advertiserDomain: any) => advertiserDomain.domain || "-"}
      onChange={advertiserDomains => onChange(advertiserDomains as IAdvertiserDomain[])}
      searchEntities={filter => searchAdvertiserDomainByName(filter)}
    />
  )
)
